import { AuthActionTypes } from '../../../enums/ActionEnums';
export const initialAuthReducerState = {
    authenticated: false,
    loading: false,
    loadingGuest: false,
    loadingReturnGuest: false,
    error: null,
    errorGuest: null,
    errorReturnGuest: null,
    resetPassword: {
        error: null,
        success: null,
    },
    social: {
        initialized: [],
    },
    loggedGuest: false,
    loggedInReturnGuest: false,
};
export const authReducer = (state = initialAuthReducerState, action) => {
    switch (action.type) {
        case AuthActionTypes.LOGIN_SUCCESS:
            return Object.assign(Object.assign({}, state), { error: null, loading: false, authenticated: true });
        case AuthActionTypes.LOGIN:
        case AuthActionTypes.REGISTERED_LOGIN:
        case AuthActionTypes.LOGOUT:
            return Object.assign(Object.assign({}, state), { loading: true });
        case AuthActionTypes.LOGIN_GUEST:
            return Object.assign(Object.assign({}, state), { loadingGuest: true });
        case AuthActionTypes.LOGIN_RETURN_GUEST:
            return Object.assign(Object.assign({}, state), { loadingReturnGuest: true });
        case AuthActionTypes.LOGIN_FAIL:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case AuthActionTypes.RESET_ERROR:
            return Object.assign(Object.assign({}, state), { error: null, errorGuest: null });
        case AuthActionTypes.LOGOUT_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, authenticated: false });
        case AuthActionTypes.RESET_PASSWORD:
            return Object.assign(Object.assign({}, state), { resetPassword: Object.assign(Object.assign({}, state.resetPassword), { error: null, success: null }) });
        case AuthActionTypes.RESET_PASSWORD_ERROR:
            return Object.assign(Object.assign({}, state), { resetPassword: Object.assign(Object.assign({}, state.resetPassword), { error: action.payload, success: null }) });
        case AuthActionTypes.RESET_PASSWORD_SUCCESS:
            return Object.assign(Object.assign({}, state), { resetPassword: Object.assign(Object.assign({}, state.resetPassword), { error: null, success: action.payload }) });
        case AuthActionTypes.LOAD_SOCIAL_SUCCESS:
            return Object.assign(Object.assign({}, state), { social: Object.assign(Object.assign({}, state.social), { initialized: [...state.social.initialized, action.payload] }) });
        case AuthActionTypes.LOGIN_GUEST_SUCCESS:
            return Object.assign(Object.assign({}, state), { loggedGuest: true, loadingGuest: false });
        case AuthActionTypes.LOGIN_GUEST_FAIL:
            return Object.assign(Object.assign({}, state), { loadingGuest: false, errorGuest: action.payload });
        case AuthActionTypes.LOGIN_RETURN_GUEST_SUCCESS:
            return Object.assign(Object.assign({}, state), { loggedInReturnGuest: true, loadingReturnGuest: false });
        case AuthActionTypes.LOGIN_RETURN_GUEST_FAIL:
            return Object.assign(Object.assign({}, state), { loadingReturnGuest: false, errorReturnGuest: action.payload });
        case AuthActionTypes.UPDATE_USER_AUTH_STATE:
            return Object.assign(Object.assign({}, state), { authenticated: action.payload.authenticated });
        default:
            return state;
    }
};
